/** Minimal markdown → React nodes for blog posts (headings, paragraphs, bold, links). */
export function parseMarkdownToBlocks(text = '') {
  if (!text) return [];

  const blocks = [];
  const lines = text.replace(/\r\n/g, '\n').split('\n');
  let paragraph = [];

  const flushParagraph = () => {
    const joined = paragraph.join(' ').trim();
    if (joined) blocks.push({ type: 'p', text: joined });
    paragraph = [];
  };

  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed) {
      flushParagraph();
      continue;
    }
    if (trimmed.startsWith('### ')) {
      flushParagraph();
      blocks.push({ type: 'h3', text: trimmed.slice(4).trim() });
      continue;
    }
    if (trimmed.startsWith('## ')) {
      flushParagraph();
      blocks.push({ type: 'h2', text: trimmed.slice(3).trim() });
      continue;
    }
    if (trimmed.startsWith('# ')) {
      flushParagraph();
      blocks.push({ type: 'h2', text: trimmed.slice(2).trim() });
      continue;
    }
    paragraph.push(trimmed);
  }
  flushParagraph();
  return blocks;
}

function inlineParts(text) {
  const parts = [];
  const re = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g;
  let last = 0;
  let match;

  while ((match = re.exec(text)) !== null) {
    if (match.index > last) {
      parts.push({ type: 'text', value: text.slice(last, match.index) });
    }
    const token = match[0];
    if (token.startsWith('**')) {
      parts.push({ type: 'bold', value: token.slice(2, -2) });
    } else {
      const m = token.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
      if (m) parts.push({ type: 'link', label: m[1], href: m[2] });
    }
    last = match.index + token.length;
  }
  if (last < text.length) {
    parts.push({ type: 'text', value: text.slice(last) });
  }
  return parts.length ? parts : [{ type: 'text', value: text }];
}

export function renderInline(text) {
  return inlineParts(text).map((part, i) => {
    if (part.type === 'bold') {
      return <strong key={i}>{part.value}</strong>;
    }
    if (part.type === 'link') {
      return (
        <a key={i} href={part.href} className="text-violet-900 hover:underline">
          {part.label}
        </a>
      );
    }
    return <span key={i}>{part.value}</span>;
  });
}

/** Drop leading line if it duplicates the post title. */
export function normalizeBlogContent(content, title) {
  if (!content || !title) return content || '';
  const lines = content.replace(/\r\n/g, '\n').split('\n');
  const firstNonEmpty = lines.find((l) => l.trim());
  if (firstNonEmpty && firstNonEmpty.trim() === title.trim()) {
    const idx = lines.indexOf(firstNonEmpty);
    return lines.slice(idx + 1).join('\n').trim();
  }
  return content;
}
